import { useState } from 'react';
import { toast } from '@cencosud-cencommerce/paris-uikit';

import { useRepository } from '@/Application/Providers/Repository';
import { removeLineItem } from '@/modules/cart/application/removeLineItem';
import type { Cart } from '@/modules/cart/domain/Cart';
import type { MutatorHook } from '@/sections/shared/types/MutatorHook';

const useRemoveLineItem = (): MutatorHook<string, Cart | undefined> => {
  const { cart: cartRepository } = useRepository();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const trigger = async (lineItemId: string) => {
    setIsLoading(true);
    try {
      const res = await removeLineItem(cartRepository, lineItemId);
      if (!res) {
        throw new Error('No se pudo eliminar el producto');
      }

      toast({
        status: 'success',
        title: 'Eliminaste un producto del carro'
      });

      return res;
    } catch (e) {
      toast({
        status: 'error',
        title: 'No pudimos eliminar el producto',
        body: 'Por favor, intenta de nuevo.'
      });
      setError((e as Error).message);
    } finally {
      setIsLoading(false);
    }
  };

  return { trigger, isLoading, error };
};

export default useRemoveLineItem;
